const CEP_DIGITS_LENGTH = 8;

/**
 * @param {string} zipCode raw input value
 * @returns {string} only the digits
 */
export const getCepDigits = (zipCode) => (zipCode ?? "").replace(/\D/g, "");

/**
 * Checks a CEP is well-formed and actually exists, consulting ViaCEP.
 *
 * @param {string} zipCode raw input value
 * @returns {Promise<boolean>}
 */
export async function cepExists (zipCode) {
  const digits = getCepDigits(zipCode);
  if (digits.length !== CEP_DIGITS_LENGTH) {
    return false;
  }

  try {
    const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    if (!response.ok) {
      // Fail-open: don't block checkout if the CEP lookup service is unavailable
      return true;
    }
    const data = await response.json();
    return !data.erro;
  } catch (_err) {
    // Fail-open on network errors, same reasoning as above
    return true;
  }
}
